import * as THREE from 'three';

const LOGO_SRC = (window.GJAK && window.GJAK.logo) || '';
const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
const clamp01 = v => Math.min(1, Math.max(0, v));
const smooth = t => t * t * (3 - 2 * t);
const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
const lerp = (a, b, t) => a + (b - a) * t;
const mob = () => innerWidth < 820;

gsap.registerPlugin(ScrollTrigger, SplitText, ScrambleTextPlugin);
gsap.config({ nullTargetWarn: false });

/* ---------------- data ---------------- */
const F = [
  { name: 'Pure Energy', t: ['Pure', 'Energy'], notes: ['Raspberry', 'Ginger', 'Blood orange'], en: 'Raspberry · Ginger · Blood orange',
    desc: "The boldest of the range. Raspberry opens, blood orange wakes you up and ginger leaves a warmth that lasts.",
    can: '#9e141c', deep: '#1c0204', glow: '#b3161f', bright: '#ff3b45' },
  { name: 'Stay Savage', t: ['Stay', 'Savage'], notes: ['Mango', 'Matcha', 'Ginger'], en: 'Mango · Matcha · Ginger',
    desc: "Mango for the sun, matcha for focus, ginger for the bite. A green, honest kind of energy.",
    can: '#1d5e27', deep: '#021006', glow: '#1b7a36', bright: '#3fdc74' },
  { name: 'Feel Alive', t: ['Feel', 'Alive'], notes: ['Blueberry', 'Lavender', 'Hibiscus'], en: 'Blueberry · Lavender · Hibiscus',
    desc: "Floral without being tame. Blueberry sets the base, lavender and hibiscus bring a tangy freshness.",
    can: '#44218f', deep: '#07031a', glow: '#5a2fc0', bright: '#9b74ff' }
];
const B = [
  { icon: 'leaf', title: 'Real fruit', strike: 'Flavoured syrup', txt: "Raspberry, mango, blueberry: every recipe starts with a fruit you can taste from the very first sip." },
  { icon: 'root', title: 'Roots & flowers', strike: 'Synthetic flavours', txt: "Ginger, matcha, lavender and hibiscus give each flavour its character, with no lab-made aromas." },
  { icon: 'bolt', title: 'Plant energy', strike: 'Synthetic caffeine', txt: "A clean, plant-based boost. Exact caffeine source and dosage to be confirmed." },
  { icon: 'drop', title: 'Just sweet enough', strike: 'Sugar overload', txt: "Enough for the pleasure, without the crash that follows. Sugar content to be confirmed." }
];
const ICONS = {
  leaf: '<path d="M5 19c8 0 14-6 14-14-8 0-14 6-14 14Z"/><path d="M5 19 13 11"/>',
  root: '<path d="M12 3v7"/><path d="M12 10c-3 1-5 4-5 8"/><path d="M12 10c3 1 5 4 5 8"/><path d="M12 10v9"/><circle cx="12" cy="3" r="1"/>',
  bolt: '<path d="M13 2 5 13h6l-1 9 8-12h-6l1-8Z"/>',
  drop: '<path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11Z"/>'
};

/* ---------------- logo processing ---------------- */
function loadImg(src) { return new Promise((res, rej) => { const i = new Image(); i.crossOrigin = 'anonymous'; i.onload = () => res(i); i.onerror = rej; i.src = src; }); }
function whiteLogo(img, crop, keepDrop = true) {
  const [cx, cy, cw, ch] = crop;
  const c = document.createElement('canvas'); c.width = cw; c.height = ch;
  const x = c.getContext('2d'); x.drawImage(img, -cx, -cy);
  const d = x.getImageData(0, 0, cw, ch), p = d.data;
  for (let y = 0; y < ch; y++) for (let xx = 0; xx < cw; xx++) {
    const i = (y * cw + xx) * 4, r = p[i], g = p[i + 1], b = p[i + 2], al = p[i + 3] / 255;
    const X = xx + cx, Y = y + cy;
    const inDrop = X > 686 && X < 800 && Y > 680 && Y < 852;
    const lum = (r + g + b) / 3;
    if (inDrop && keepDrop && lum < 246 && al > .5) { continue; }
    if (inDrop && !keepDrop) { p[i + 3] = 0; continue; }
    p[i] = p[i + 1] = p[i + 2] = 255; p[i + 3] = Math.max(0, Math.min(255, (255 - lum) * 1.15 * al));
  }
  x.putImageData(d, 0, 0); return c;
}
function dropOnly(img) {
  const [cx, cy, cw, ch] = [686, 680, 114, 172];
  const c = document.createElement('canvas'); c.width = cw; c.height = ch;
  const x = c.getContext('2d'); x.drawImage(img, -cx, -cy);
  const d = x.getImageData(0, 0, cw, ch), p = d.data;
  for (let i = 0; i < p.length; i += 4) { const lum = (p[i] + p[i + 1] + p[i + 2]) / 3; if (lum > 246 || p[i + 3] < 128) p[i + 3] = 0; }
  x.putImageData(d, 0, 0); return c.toDataURL('image/png');
}
function tint(src, color) {
  const c = document.createElement('canvas'); c.width = src.width; c.height = src.height;
  const x = c.getContext('2d'); x.drawImage(src, 0, 0); x.globalCompositeOperation = 'source-in'; x.fillStyle = color; x.fillRect(0, 0, c.width, c.height); return c;
}

/* ---------------- can label ---------------- */
const LW = 2048, LH = 1500;
const ROWS_Y = [470, 690, 910, 1130]; // back label rows (px)
let WORD, EST, WORD_MR;
function barcode(x, cx, cy, w, h) {
  x.save(); x.translate(cx, cy); x.fillStyle = '#fff'; x.fillRect(-10, -10, w + 20, h + 40);
  x.fillStyle = '#111'; let px = 0, s = 7;
  while (px < w) { const bw = 2 + ((s = (s * 9301 + 49297) % 233280) / 233280) * 6; if (((s >> 3) & 1) === 0) x.fillRect(px, 0, bw, h); px += bw + 2; }
  x.font = '500 18px Geist Mono, monospace'; x.fillText('5 4 1 0 2 4  1 7 0 9 2', 4, h + 22); x.restore();
}
function drawLabel(ctx, f, mode, hi = -1) {
  const isMR = mode === 'mr';
  const INK = isMR ? 'rgb(0,150,12)' : '#f7f3ec';
  const DIM = isMR ? 'rgb(0,150,12)' : 'rgba(247,243,236,.55)';
  // base
  if (isMR) { ctx.fillStyle = 'rgb(0,72,215)'; ctx.fillRect(0, 0, LW, LH); }
  else {
    const g = ctx.createLinearGradient(0, 0, 0, LH);
    const c = new THREE.Color(f.can);
    const lighter = c.clone().offsetHSL(0, 0, .06).getStyle(), darker = c.clone().offsetHSL(0, 0, -.06).getStyle();
    g.addColorStop(0, lighter); g.addColorStop(.5, f.can); g.addColorStop(1, darker);
    ctx.fillStyle = g; ctx.fillRect(0, 0, LW, LH);
    // brushed aluminium streaks
    const sh = ctx.createLinearGradient(0, 0, 0, LH);
    sh.addColorStop(0, 'rgba(0,0,0,.28)'); sh.addColorStop(.035, 'rgba(0,0,0,0)'); sh.addColorStop(.965, 'rgba(0,0,0,0)'); sh.addColorStop(1, 'rgba(0,0,0,.32)');
    ctx.fillStyle = sh; ctx.fillRect(0, 0, LW, LH);
    ctx.globalAlpha = .018;
    for (let i = 0; i < 600; i++) { ctx.fillStyle = Math.random() > .5 ? '#fff' : '#000'; ctx.fillRect(Math.random() * LW, 0, 1 + Math.random() * 2, LH); }
    ctx.globalAlpha = 1;
  }
  // front : vertical wordmark
  const word = isMR ? WORD_MR : WORD;
  const wH = 900, sc = wH / word.width, wW = word.height * sc;
  ctx.save(); ctx.translate(1024, 150 + wH / 2); ctx.rotate(-Math.PI / 2);
  ctx.drawImage(word, -wH / 2, -wW / 2, wH, wW); ctx.restore();
  ctx.fillStyle = INK; ctx.textAlign = 'center';
  ctx.font = '500 62px "Bodoni Moda", Georgia, serif';
  ctx.fillText(f.name.toUpperCase(), 1024, 1165);
  ctx.font = 'italic 500 34px "Bodoni Moda", Georgia, serif'; ctx.fillStyle = DIM;
  ctx.fillText(f.en, 1024, 1232);
  ctx.fillStyle = INK; ctx.font = '500 40px "Bodoni Moda", Georgia, serif';
  ctx.fillText('EST. 2024', 1024, 1360);
  // back : recipe rows (centred on the seam, drawn twice)
  for (const ox of [0, LW]) {
    ctx.save(); ctx.translate(ox, 0); ctx.textAlign = 'left';
    ctx.fillStyle = INK; ctx.font = '900 italic 64px Archivo, sans-serif';
    ctx.fillText('THE GJAK', -300, 230);
    ctx.fillText('RECIPE', -300, 300);
    ctx.fillStyle = DIM; ctx.font = '500 22px "Geist Mono", monospace';
    ctx.fillText('FRUITS · ROOTS · FLOWERS', -300, 350);
    B.forEach((b, i) => drawRow(ctx, f, b, ROWS_Y[i], hi === i, hi >= 0 && hi !== i, isMR));
    ctx.restore();
  }
  // sides : nutrition + barcode
  ctx.textAlign = 'left'; ctx.fillStyle = DIM; ctx.font = '500 20px "Geist Mono", monospace';
  ['ENERGY DRINK', 'WITH REAL FRUIT', '250 ML', '', 'NUTRITION FACTS', 'PER 100 ML', 'ENERGY ....... XX KCAL', 'SUGARS ....... X G', 'CAFFEINE ..... XX MG', '', 'HIGH CAFFEINE CONTENT.', 'NOT RECOMMENDED FOR', 'CHILDREN OR PREGNANT WOMEN.'].forEach((l, i) => ctx.fillText(l, 470, 420 + i * 34));
  if (!isMR) barcode(ctx, 1500, 560, 190, 110); else { ctx.fillStyle = 'rgb(0,150,12)'; ctx.fillRect(1490, 550, 210, 170); }
}
function drawRow(ctx, f, b, y, on, off, isMR) {
  const INK = isMR ? 'rgb(0,150,12)' : '#f7f3ec', DIM = isMR ? 'rgb(0,150,12)' : 'rgba(247,243,236,.55)';
  ctx.save(); ctx.textAlign = 'left';
  ctx.globalAlpha = off ? .26 : 1;
  if (!isMR && on) { ctx.shadowColor = f.bright; ctx.shadowBlur = 40; }
  ctx.strokeStyle = on && !isMR ? f.bright : INK; ctx.lineWidth = 5;
  ctx.beginPath(); ctx.arc(-250, y - 20, 42, 0, Math.PI * 2); ctx.stroke();
  ctx.fillStyle = on && !isMR ? f.bright : INK;
  ctx.font = '900 italic 52px Archivo, sans-serif'; ctx.fillText(b.title.toUpperCase(), -180, y);
  ctx.shadowBlur = 0;
  ctx.font = '500 26px "Geist Mono", monospace'; ctx.fillStyle = on && !isMR ? 'rgba(255,255,255,.8)' : DIM;
  const sw = ctx.measureText(b.strike.toUpperCase()).width;
  ctx.fillText(b.strike.toUpperCase(), -180, y + 46);
  ctx.fillRect(-180, y + 37, sw, 3);
  ctx.font = '400 24px Geist, sans-serif';
  ctx.fillText(b.txt.slice(0, 44) + '…', -180, y + 86);
  ctx.restore();
}
// glowing overlay for one highlighted row (drawn once, crossfaded on the can => no label redraw while scrolling)
const ROW_W = 820, ROW_H = 220, ROW_OFF = 110;
const ROW_TEX = [];
function makeRowTex(f, i, renderer) {
  const c = document.createElement('canvas'); c.width = ROW_W; c.height = ROW_H;
  const x = c.getContext('2d'); x.translate(ROW_W / 2, 0);
  drawRow(x, f, B[i], ROW_OFF, true, false, false);
  const t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; t.anisotropy = renderer.capabilities.getMaxAnisotropy(); return t;
}
function makeLabelTex(f, renderer, hi = -1) {
  const c = document.createElement('canvas'); c.width = LW; c.height = LH;
  drawLabel(c.getContext('2d'), f, 'color', hi);
  const t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; t.anisotropy = renderer.capabilities.getMaxAnisotropy();
  t.userData.canvas = c; return t;
}
let MR_TEX = [];
function makeMRTex(renderer, f) {
  const c = document.createElement('canvas'); c.width = LW; c.height = LH;
  drawLabel(c.getContext('2d'), f, 'mr', -1);
  const t = new THREE.CanvasTexture(c); t.anisotropy = renderer.capabilities.getMaxAnisotropy(); return t;
}

/* ---------------- three scene ---------------- */
const canvas = $('#gl');
const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
renderer.setPixelRatio(Math.min(devicePixelRatio, innerWidth < 820 ? 1.5 : 2));
renderer.setClearColor(0x000000, 0);
renderer.toneMapping = THREE.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.12;
renderer.shadowMap.enabled = true; renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.outputColorSpace = THREE.SRGBColorSpace;
const scene = new THREE.Scene();
const pmrem = new THREE.PMREMGenerator(renderer);
// studio "softbox" environment: dark room + bright strips => vertical highlights on the cylinders
function studioEnv() {
  const env = new THREE.Scene();
  env.add(new THREE.Mesh(new THREE.BoxGeometry(30, 30, 30), new THREE.MeshBasicMaterial({ color: 0x050505, side: THREE.BackSide })));
  const strip = (w, h, x, y, z, ry, rx, v) => { const m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color: new THREE.Color(v, v, v), side: THREE.DoubleSide })); m.position.set(x, y, z); m.rotation.set(rx, ry, 0); env.add(m); };
  strip(1.4, 12, -7, 1, 3, Math.PI / 2.4, 0, 6);    // key strip, left-front
  strip(.6, 12, 7.5, 1, 1, -Math.PI / 2, 0, 3.2);   // thin rim strip, right
  strip(.5, 12, -6, 0, -6, Math.PI / 4, 0, 1.6);    // back-left kicker
  strip(6, 6, 0, 9, 0, 0, Math.PI / 2, 2.2);        // overhead softbox
  strip(10, 1.2, 0, -8, 4, 0, -Math.PI / 2.2, .35); // faint floor bounce
  return env;
}
scene.environment = pmrem.fromScene(studioEnv(), .02).texture;
scene.fog = new THREE.Fog(0x000000, 11, 21);
const camera = new THREE.PerspectiveCamera(28, innerWidth / innerHeight, .1, 100);
camera.position.set(0, 0, 10);

const key = new THREE.DirectionalLight(0xfff4ea, 2.6); key.position.set(-4, 7, 6); scene.add(key); scene.add(key.target);
key.castShadow = true; key.shadow.mapSize.set(2048, 2048); key.shadow.bias = -.0004; key.shadow.normalBias = .02;
Object.assign(key.shadow.camera, { left: -9, right: 9, top: 9, bottom: -9, near: 1, far: 40 }); key.shadow.radius = 6;
const fill = new THREE.DirectionalLight(0x9fb4ff, .25); fill.position.set(5, -1, 4); scene.add(fill);
// spotlight from the top pedestal onto the selected can
const spot = new THREE.SpotLight(0xffffff, 0, 9, .3, .55, 1.2); spot.position.set(0, 2.3, .15); scene.add(spot, spot.target);
const beam = new THREE.Mesh(new THREE.CylinderGeometry(.3, 1.05, 3.5, 64, 1, true), new THREE.ShaderMaterial({
  transparent: true, depthWrite: false, blending: THREE.AdditiveBlending, side: THREE.DoubleSide,
  uniforms: { uO: { value: 0 } },
  vertexShader: 'varying vec2 vUv; varying float vF; void main(){ vUv = uv; vec4 mv = modelViewMatrix * vec4(position,1.); vec3 n = normalize(normalMatrix * normal); vF = abs(dot(n, normalize(-mv.xyz))); gl_Position = projectionMatrix * mv; }',
  fragmentShader: 'uniform float uO; varying vec2 vUv; varying float vF; void main(){ float a = pow(vF, 2.2) * smoothstep(0., .9, vUv.y) * (.35 + .65 * vUv.y); gl_FragColor = vec4(vec3(1.), a * .16 * uO); }'
}));
beam.position.set(0, .15, -.35); scene.add(beam);
// soft floor that only receives shadows (hero)
const floor = new THREE.Mesh(new THREE.PlaneGeometry(40, 40), new THREE.ShadowMaterial({ opacity: .45 }));
floor.rotation.x = -Math.PI / 2; floor.receiveShadow = true; scene.add(floor);
const rimL = new THREE.PointLight(0xff3344, 40, 20); rimL.position.set(-4, 1, -2); scene.add(rimL);
const rimR = new THREE.PointLight(0xff3344, 40, 20); rimR.position.set(4, 2, -2); scene.add(rimR);
const topL = new THREE.SpotLight(0xffffff, 60, 30, .5, .8); topL.position.set(0, 9, 3); scene.add(topL); scene.add(topL.target);
scene.add(new THREE.AmbientLight(0xffffff, .03));

const R = .5, H = 2.3;
const bodyGeo = new THREE.CylinderGeometry(R, R, H, 128, 1, true, Math.PI, Math.PI * 2);
const neckPts = [[R, H / 2], [R, H / 2 + .03], [.47, H / 2 + .1], [.455, H / 2 + .13]].map(p => new THREE.Vector2(p[0], p[1]));
const neckGeo = new THREE.LatheGeometry(neckPts, 96);
const lidPts = [[.455, H / 2 + .128], [.44, H / 2 + .165], [.452, H / 2 + .18], [.445, H / 2 + .197], [.428, H / 2 + .19], [.415, H / 2 + .155], [.2, H / 2 + .15], [0, H / 2 + .15]].map(p => new THREE.Vector2(p[0], p[1]));
const lidGeo = new THREE.LatheGeometry(lidPts, 96);
const botPts = [[0, -H / 2 - .045], [.25, -H / 2 - .06], [.4, -H / 2 - .1], [.445, -H / 2 - .1], [.49, -H / 2 - .05], [R, -H / 2]].map(p => new THREE.Vector2(p[0], p[1]));
const botGeo = new THREE.LatheGeometry(botPts, 96);
const tabGeo = new THREE.BoxGeometry(.2, .012, .34);
let CAP_MATS = [];
const ALU = new THREE.MeshPhysicalMaterial({ color: 0xc9ccd1, metalness: 1, roughness: .2, clearcoat: .3, side: THREE.DoubleSide, envMapIntensity: 1.1 });
function capMat(f) { const c = new THREE.Color(f.can); return new THREE.MeshPhysicalMaterial({ color: c, metalness: .85, roughness: .3, clearcoat: .6, clearcoatRoughness: .18, side: THREE.DoubleSide, envMapIntensity: 1 }); }
function tabMat(f) { const c = new THREE.Color(f.can).offsetHSL(0, -.05, -.06); return new THREE.MeshPhysicalMaterial({ color: c, metalness: .9, roughness: .24, clearcoat: .5, envMapIntensity: 1.1 }); }

let LABELS = [], HERO_TEX = [], BODY_MATS = [];
function bodyMat(tex, i) {
  return new THREE.MeshPhysicalMaterial({ map: tex, metalnessMap: MR_TEX[i], roughnessMap: MR_TEX[i], metalness: 1, roughness: 1, clearcoat: .55, clearcoatRoughness: .2, envMapIntensity: .9 });
}
// ---- lid details (opercule) ----
const LID_Y = H / 2 + .15;
const tabGeo2 = (() => {
  const sh = new THREE.Shape(), rc = -.12, rr = .085, nc = .1, nr = .058;
  for (let i = 0; i <= 24; i++) { const a = Math.PI + i / 24 * Math.PI; const x = rr * Math.cos(a), y = rc + rr * Math.sin(a); i ? sh.lineTo(x, y) : sh.moveTo(x, y); }
  for (let i = 0; i <= 24; i++) { const a = i / 24 * Math.PI; sh.lineTo(nr * Math.cos(a), nc + nr * Math.sin(a)); }
  const hole = new THREE.Path(); hole.absellipse(0, -.128, .05, .036, 0, Math.PI * 2, false); sh.holes.push(hole);
  const g = new THREE.ExtrudeGeometry(sh, { depth: .006, bevelEnabled: true, bevelThickness: .002, bevelSize: .003, bevelSegments: 2, curveSegments: 24 });
  g.rotateX(Math.PI / 2); return g;
})();
const panelShape = (() => {
  const sh = new THREE.Shape(); sh.moveTo(.075, .05);
  for (let i = 0; i <= 28; i++) { const a = i / 28 * Math.PI; sh.lineTo(.092 * Math.cos(a), .2 + .092 * Math.sin(a)); }
  sh.lineTo(-.075, .05); sh.lineTo(.075, .05); return sh;
})();
const panelGeo = new THREE.ShapeGeometry(panelShape, 24); panelGeo.rotateX(Math.PI / 2); panelGeo.translate(0, 0, -.05);
const grooveGeo = new THREE.ShapeGeometry(panelShape, 24); grooveGeo.translate(0, -.17, 0); grooveGeo.scale(1.09, 1.07, 1); grooveGeo.translate(0, .17, 0); grooveGeo.rotateX(Math.PI / 2);
const rivetGeo = new THREE.CylinderGeometry(.028, .034, .016, 24);
const HOLE_MAT = new THREE.MeshBasicMaterial({ color: 0x030303, side: THREE.DoubleSide });
function addLid(g, alu) {
  const groove = new THREE.Mesh(grooveGeo, HOLE_MAT); groove.position.y = LID_Y + .002; g.add(groove);
  const panelPivot = new THREE.Group(); panelPivot.position.set(0, LID_Y + .004, .05);
  panelPivot.add(new THREE.Mesh(panelGeo, alu)); g.add(panelPivot);
  const rivet = new THREE.Mesh(rivetGeo, alu); rivet.position.set(0, LID_Y + .008, 0); g.add(rivet);
  const tabPivot = new THREE.Group(); tabPivot.position.set(0, LID_Y + .02, 0);
  tabPivot.add(new THREE.Mesh(tabGeo2, alu)); g.add(tabPivot);
  return { tabPivot, panelPivot };
}
// own = true : the can gets its own material copies so it can be dimmed individually (ring)
function makeCan(mat, fi, own = false) {
  const g = new THREE.Group();
  const cl = m => { if (!own) return m; const c = m.clone(); c.userData.base = m.color.clone(); c.userData.env = m.envMapIntensity; return c; };
  const body = new THREE.Mesh(bodyGeo, cl(mat));
  const neck = new THREE.Mesh(neckGeo, cl(CAP_MATS[fi].cap));
  const alu = cl(ALU);
  const lid = new THREE.Mesh(lidGeo, alu), bot = new THREE.Mesh(botGeo, alu);
  g.add(body, neck, lid, bot);
  const lidParts = addLid(g, alu);
  g.traverse(o => { if (o.isMesh) { o.castShadow = true; o.receiveShadow = true; } });
  g.userData = { body, neck, ...lidParts, mats: own ? [body.material, neck.material, alu] : [] }; return g;
}
function setCanFlavor(g, fi) { g.userData.neck.material = CAP_MATS[fi].cap; }
function dimCan(g, b) {
  g.userData.mats.forEach(m => { m.color.copy(m.userData.base).multiplyScalar(b); m.envMapIntensity = m.userData.env * b; if (m.clearcoat) m.clearcoat = m.userData.cc ?? (m.userData.cc = m.clearcoat); });
}

// pedestal
function pedestal(flip) {
  const g = new THREE.Group();
  const m = new THREE.MeshStandardMaterial({ color: 0x151515, metalness: .9, roughness: .35 });
  const d1 = new THREE.Mesh(new THREE.CylinderGeometry(1.05, 1.15, .18, 96), m); g.add(d1);
  const d2 = new THREE.Mesh(new THREE.CylinderGeometry(.8, .8, .1, 96), m); d2.position.y = flip ? -.13 : .13; g.add(d2);
  const glow = new THREE.Mesh(new THREE.TorusGeometry(.92, .012, 12, 128), new THREE.MeshBasicMaterial({ color: 0xffffff }));
  glow.rotation.x = Math.PI / 2; glow.position.y = flip ? -.1 : .1; g.add(glow);
  const glow2 = new THREE.Mesh(new THREE.TorusGeometry(1.1, .006, 8, 128), new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: .5 }));
  glow2.rotation.x = Math.PI / 2; g.add(glow2);
  return g;
}
const pedBot = pedestal(false), pedTop = pedestal(true);
pedBot.traverse(o => { if (o.isMesh) o.receiveShadow = true; });
scene.add(pedBot, pedTop);

// groups
const N = 24, RING_R = 5.4;
const ring = new THREE.Group(); scene.add(ring);
const ringCans = [];
const heroCan = new THREE.Group(); scene.add(heroCan);
const line = new THREE.Group(); scene.add(line);
const lineCans = [];

/* ---------------- splash ---------------- */
const SPL_N = 280;
const splash = new THREE.InstancedMesh(new THREE.SphereGeometry(1, 12, 10),
  new THREE.MeshPhysicalMaterial({ color: 0xffffff, roughness: .06, metalness: 0, clearcoat: 1, clearcoatRoughness: .04, envMapIntensity: 1.8 }), SPL_N);
splash.count = 0; splash.frustumCulled = false; scene.add(splash);
const drops = [];
const _m = new THREE.Matrix4(), _q = new THREE.Quaternion(), _s = new THREE.Vector3(), _up = new THREE.Vector3(0, 1, 0), _d = new THREE.Vector3();
function burst(can, color) {
  splash.material.color.set(color);
  can.updateMatrixWorld(true);
  const mouth = can.localToWorld(new THREE.Vector3(0, LID_Y + .02, .19));
  const up = new THREE.Vector3(0, 1, 0).applyQuaternion(can.getWorldQuaternion(new THREE.Quaternion())).normalize();
  const s1 = new THREE.Vector3().crossVectors(up, new THREE.Vector3(0, 0, 1)).normalize(), s2 = new THREE.Vector3().crossVectors(up, s1);
  for (let i = 0; i < SPL_N; i++) {
    const big = i < 18, sp = big ? 2 + Math.random() * 1.6 : 2.4 + Math.random() * 4.2;
    const a = Math.random() * Math.PI * 2, r = Math.pow(Math.random(), .6) * (big ? .45 : 1.25);
    const v = up.clone().multiplyScalar(sp).addScaledVector(s1, Math.cos(a) * r * sp * .38).addScaledVector(s2, Math.sin(a) * r * sp * .38);
    drops[i] = { p: mouth.clone(), v, life: 0, max: .8 + Math.random() * 1.2, s: big ? .03 + Math.random() * .03 : .006 + Math.random() * .02, delay: Math.random() * .22 };
  }
}
function updateSplash(dt) {
  let n = 0;
  for (const d of drops) {
    if (!d) continue;
    if (d.delay > 0) { d.delay -= dt; continue; }
    d.life += dt; if (d.life > d.max) continue;
    d.v.y -= 9 * dt; d.v.multiplyScalar(1 - .5 * dt); d.p.addScaledVector(d.v, dt);
    const k = 1 - Math.pow(d.life / d.max, 3), spd = d.v.length();
    _d.copy(d.v).normalize(); _q.setFromUnitVectors(_up, _d);
    _s.set(d.s * k, d.s * k * (1 + Math.min(spd * .14, 1.6)), d.s * k);
    _m.compose(d.p, _q, _s); splash.setMatrixAt(n++, _m);
  }
  splash.count = n; if (n) splash.instanceMatrix.needsUpdate = true;
}

/* ---------------- state ---------------- */
const PR = { hero: 0, flavors: 0, benefits: 0, manifest: 0, lineup: 0 }; // raw scroll progress
const P = { hero: 0, flavors: 0, benefits: 0, manifest: 0, lineup: 0 };  // damped, drives the scene
let ringA = 0, ringTarget = 0, active = 0, lockedFlavor = null, introT = 0, curTex = -1, curHi = -2, curBStep = -1, curFStep = -1;
const OPEN = { t: 0, burst: false, armed: false }; let lidTilt = 0;
const order = () => { const f = lockedFlavor ?? active; return [f, (f + 1) % 3, (f + 2) % 3]; };

/* ---------------- sound (synth, off by default) ---------------- */
let AC = null, soundOn = false;
function blip(freq = 1400, dur = .05, vol = .05) {
  if (!soundOn) return; AC = AC || new (window.AudioContext || window.webkitAudioContext)();
  const o = AC.createOscillator(), g = AC.createGain(); o.type = 'sine'; o.frequency.value = freq;
  g.gain.setValueAtTime(vol, AC.currentTime); g.gain.exponentialRampToValueAtTime(.0001, AC.currentTime + dur);
  o.connect(g).connect(AC.destination); o.start(); o.stop(AC.currentTime + dur);
}
function whoosh() {
  if (!soundOn) return; AC = AC || new AudioContext();
  const len = AC.sampleRate * .45, buf = AC.createBuffer(1, len, AC.sampleRate), d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2);
  const s = AC.createBufferSource(); s.buffer = buf; const f = AC.createBiquadFilter(); f.type = 'bandpass'; f.frequency.setValueAtTime(400, AC.currentTime); f.frequency.exponentialRampToValueAtTime(2400, AC.currentTime + .4);
  const g = AC.createGain(); g.gain.value = .06; s.connect(f).connect(g).connect(AC.destination); s.start();
}
function pshitt() {
  if (!soundOn) return; AC = AC || new AudioContext(); const t0 = AC.currentTime;
  const o = AC.createOscillator(), og = AC.createGain(); o.type = 'triangle';
  o.frequency.setValueAtTime(1100, t0); o.frequency.exponentialRampToValueAtTime(140, t0 + .05);
  og.gain.setValueAtTime(.14, t0); og.gain.exponentialRampToValueAtTime(.0001, t0 + .07); o.connect(og).connect(AC.destination); o.start(t0); o.stop(t0 + .08);
  const len = AC.sampleRate * .95, buf = AC.createBuffer(1, len, AC.sampleRate), d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
  const n = AC.createBufferSource(); n.buffer = buf;
  const hp = AC.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = 2400;
  const pk = AC.createBiquadFilter(); pk.type = 'peaking'; pk.frequency.value = 6500; pk.gain.value = 9;
  const g = AC.createGain(); g.gain.setValueAtTime(0, t0 + .02); g.gain.linearRampToValueAtTime(.26, t0 + .045); g.gain.exponentialRampToValueAtTime(.0001, t0 + .9);
  n.connect(hp).connect(pk).connect(g).connect(AC.destination); n.start(t0 + .02); n.stop(t0 + .95);
  for (let i = 0; i < 18; i++) {
    const ti = t0 + .12 + Math.random() * .7, c = AC.createOscillator(), cg = AC.createGain();
    c.frequency.value = 2800 + Math.random() * 4500; cg.gain.setValueAtTime(.018, ti); cg.gain.exponentialRampToValueAtTime(.0001, ti + .014);
    c.connect(cg).connect(AC.destination); c.start(ti); c.stop(ti + .02);
  }
}
$('#sound').addEventListener('click', e => {
  soundOn = !soundOn; e.currentTarget.classList.toggle('on', soundOn); e.currentTarget.setAttribute('aria-pressed', soundOn);
  $('#soundLbl').textContent = soundOn ? 'ON' : 'OFF'; blip(900, .08, .06);
});

/* ---------------- DOM build ---------------- */
function lettersOf(name) { return name.toUpperCase().split('').map(c => `<span>${c === ' ' ? '&nbsp;' : c}</span>`).join(''); }
function buildTexts() {
  $('#fTxt').innerHTML = F.map((_, i) => `<div class="blk" data-f="${i}"><h2 class="h-disp">${F[i].t[0]}<br>${F[i].t[1]}</h2><p>${F[i].desc}</p><div class="notes">${F[i].notes.map(n => `<span>${n}</span>`).join('')}</div></div>`).join('');
  $$('#fTxt h2').forEach(h => SplitText.create(h, { type: 'chars,lines', mask: 'lines' }));
  $$('#fTxt p').forEach(p => SplitText.create(p, { type: 'lines', mask: 'lines' }));
  $('#bTxt').innerHTML = B.map((b, i) => `<div class="blk" data-b="${i}"><div class="chip"><b>✕</b><s>${b.strike}</s></div><h2 class="h-disp">${b.title.replace(' & ', ' &amp;<br>').replace(/^(\S+) (\S+)$/, '$1<br>$2')}</h2><p>${b.txt}</p></div>`).join('');
  $$('#bTxt h2').forEach(h => SplitText.create(h, { type: 'chars,lines', mask: 'lines' }));
  $$('#bTxt p').forEach(p => SplitText.create(p, { type: 'lines', mask: 'lines' }));
}
$('#rail').innerHTML = B.map((b, i) => `<button type="button" data-i="${i}" aria-label="${b.title}"><svg viewBox="0 0 24 24">${ICONS[b.icon]}</svg></button>`).join('');

function showBlk(blk, prev) {
  if (prev && prev !== blk) {
    const pc = prev.querySelectorAll('h2 .char, h2 div div'), pl = prev.querySelectorAll('p > div > div, p .line');
    gsap.to(prev.querySelectorAll('h2 [class*="char"], h2 div div'), { yPercent: -110, duration: .32, stagger: .008, ease: 'power3.in', overwrite: true });
    gsap.to(prev.querySelectorAll('p [class*="line"], .notes span, .chip'), { autoAlpha: 0, y: -14, duration: .28, stagger: .02, ease: 'power2.in', overwrite: true, onComplete: () => prev.classList.remove('on') });
  }
  blk.classList.add('on');
  const chars = blk.querySelectorAll('h2 [class*="char"]');
  gsap.fromTo(chars, { yPercent: 115 }, { yPercent: 0, duration: .9, stagger: .022, ease: 'expo.out', delay: prev ? .34 : 0, overwrite: true });
  gsap.fromTo(blk.querySelectorAll('p [class*="line"], .notes span, .chip'), { autoAlpha: 0, y: 18 }, { autoAlpha: 1, y: 0, duration: .8, stagger: .05, ease: 'power3.out', delay: prev ? .45 : .15, overwrite: true });
  const s = blk.querySelector('.chip s'); if (s) gsap.to(s, { duration: .9, delay: prev ? .4 : .1, scrambleText: { text: s.dataset.t || (s.dataset.t = s.textContent), chars: 'upperCase', speed: .6 } });
}

/* ---------------- shop ---------------- */
const SH = window.GJAK || { products: [], cart: { items: [], item_count: 0, total_price: 0 } };
const PRICES = ((SH.products && SH.products[0]) ? SH.products[0].variants : []).map(v => ({ l: v.title, p: v.price }));
const POS = ['12.2%', '50.5%', '88.2%'];
$('#cards').innerHTML = F.map((f, i) => `<article class="card" style="--c:${f.glow}">
  <div class="media"><img class="can3d" alt="Gjak ${f.name} can" data-shot="${i}"><span class="tag mono">${f.notes.join(' · ')}</span><span class="idx mono">0${i + 1}</span></div>
  <div class="body"><h3 class="h-disp"><a href="${(SH.products[i] || {}).url || '#'}">${f.name}</a></h3><div class="notes">${f.en}</div>
  <div class="seg" data-f="${i}">${PRICES.map((p, j) => `<button type="button" class="${j ? '' : 'on'}" data-j="${j}">${p.l}</button>`).join('')}</div>
  <div class="buy"><span class="price" data-price="${i}">€${(((SH.products[i] && SH.products[i].variants[0]) ? SH.products[i].variants[0].price : 290) / 100).toFixed(2)}</span><button class="btn" type="button" data-add="${i}"><span class="t">Add to cart</span><span class="t2">Added ✓</span></button></div></div></article>`).join('');
const eur = c => '€' + (c / 100).toFixed(2);
$$('.seg').forEach(seg => seg.addEventListener('click', e => {
  const b = e.target.closest('button'); if (!b) return; seg.querySelectorAll('button').forEach(x => x.classList.toggle('on', x === b));
  $(`[data-price="${seg.dataset.f}"]`).textContent = eur(SH.products[seg.dataset.f].variants[b.dataset.j].price); blip(1800, .03, .03);
}));
let CART = SH.cart || { items: [], item_count: 0, total_price: 0 };
const HANDLES = ['pure-energy', 'stay-savage', 'feel-alive'];
const swColor = h => { const i = HANDLES.indexOf(h); return i >= 0 ? F[i].glow : '#6a1a2a'; };
function renderCart() {
  $('#cartN').textContent = CART.item_count; $('#cartN2').textContent = CART.item_count; $('#cartTotal').textContent = eur(CART.total_price);
  $('#cartItems').innerHTML = CART.items.length ? CART.items.map((it, i) => `<div class="it"><div class="sw" style="--c:${swColor(it.handle)}">${it.image ? `<img src="${it.image}${it.image.includes('?') ? '&' : '?'}width=200" alt="">` : ''}</div><div><div>${it.product_title}</div><small>${it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : ''}</small><div class="qty"><button type="button" data-q="-1" data-l="${i + 1}" data-n="${it.quantity}" aria-label="Remove one">−</button><span>${it.quantity}</span><button type="button" data-q="1" data-l="${i + 1}" data-n="${it.quantity}" aria-label="Add one">+</button></div></div><strong>${eur(it.final_line_price)}</strong></div>`).join('') : '<div class="empty mono">Your cart is empty</div>';
}
async function cartJSON(url, body) {
  const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + url.replace(/^\//, ''), body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
  const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Cart error'); return j;
}
async function refreshCart() { CART = await cartJSON('/cart.js'); renderCart(); }
$('#cartItems').addEventListener('click', async e => {
  const b = e.target.closest('[data-q]'); if (!b) return; b.disabled = true;
  try { CART = await cartJSON('/cart/change.js', { line: +b.dataset.l, quantity: Math.max(0, +b.dataset.n + +b.dataset.q) }); renderCart(); } catch (err) { console.warn(err); b.disabled = false; }
});
function openCart(o) { $('#cart').classList.toggle('on', o); $('#veil').classList.toggle('on', o); o ? lenis.stop() : lenis.start(); if (o) whoosh(); }
$('#cartBtn').onclick = () => openCart(true); $('#cartClose').onclick = () => openCart(false); $('#veil').onclick = () => openCart(false);
document.addEventListener('keydown', e => { if (e.key === 'Escape') { openCart(false); toggleMenu(false); } });
$$('[data-add]').forEach(btn => btn.addEventListener('click', async () => {
  const k = btn.dataset.add; let id;
  if (k === 'decouverte') id = SH.bundle && SH.bundle.variants[0] && SH.bundle.variants[0].id;
  else { const j = +$(`.seg[data-f="${k}"] .on`).dataset.j; id = SH.products[k] && SH.products[k].variants[j] && SH.products[k].variants[j].id; }
  if (!id) return;
  const t2 = btn.querySelector('.t2');
  btn.classList.add('done'); blip(1500, .06, .05); setTimeout(() => blip(2100, .08, .05), 70);
  try { await cartJSON('/cart/add.js', { items: [{ id, quantity: 1 }] }); await refreshCart(); t2.textContent = 'Added ✓'; }
  catch (err) { t2.textContent = 'Unavailable'; }
  setTimeout(() => { if (t2.textContent === 'Added ✓') openCart(true); btn.classList.remove('done'); setTimeout(() => { t2.textContent = 'Added ✓'; }, 500); }, 700);
}));
renderCart();
if (SH.bundle && SH.bundle.variants[0]) $('#bundlePrice').textContent = '€' + (SH.bundle.variants[0].price / 100).toFixed(2);

/* faq */
$$('.qa').forEach(q => {
  const a = q.querySelector('.a'); if (q.classList.contains('open')) a.style.height = 'auto';
  q.querySelector('button').addEventListener('click', () => {
    const o = !q.classList.contains('open'); q.classList.toggle('open', o);
    const h = a.scrollHeight; a.style.height = o ? '0px' : h + 'px'; requestAnimationFrame(() => { a.style.height = o ? h + 'px' : '0px'; });
    blip(o ? 1200 : 800, .05, .04); setTimeout(() => ScrollTrigger.refresh(), 600);
  });
});

/* menu */
function toggleMenu(o) { $('#menu').classList.toggle('open', o); $('#menuBtn').setAttribute('aria-expanded', o); $('#menu').setAttribute('aria-hidden', !o); if (o) whoosh(); }
$('#menuBtn').onclick = () => toggleMenu(!$('#menu').classList.contains('open'));

/* ---------------- lenis + scroll ---------------- */
const lenis = new Lenis({ lerp: .08, smoothWheel: true, wheelMultiplier: .9 });
lenis.stop();
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add(t => lenis.raf(t * 1000)); gsap.ticker.lagSmoothing(0);
$$('[data-go]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); toggleMenu(false); lenis.scrollTo(a.dataset.go, { duration: 2.2 }); }));
['hero', 'flavors', 'benefits', 'manifest', 'lineup'].forEach(id => ScrollTrigger.create({ trigger: '#' + id, start: 'top top', end: 'bottom bottom', onUpdate: s => { PR[id] = s.progress; } }));
ScrollTrigger.create({ start: 0, end: 'max', onUpdate: s => document.querySelector('.progress').style.setProperty('--p', s.progress.toFixed(4)) });
$('#rail').addEventListener('click', e => {
  const b = e.target.closest('button'); if (!b) return; const st = ScrollTrigger.getAll().find(t => t.trigger === $('#benefits'));
  const p = .18 + (+b.dataset.i + .3) * .205; lenis.scrollTo(st.start + (st.end - st.start) * p, { duration: 1.4 });
});

/* ---------------- ring interaction ---------------- */
const STEP = Math.PI * 2 / N;
function go(d) { ringTarget = Math.round(ringTarget / STEP) * STEP - d * STEP; lastAuto = performance.now(); }
$('#prev').onclick = () => go(-1); $('#next').onclick = () => go(1);
let drag = null, lastAuto = performance.now();
$('#drag').addEventListener('pointerdown', e => { drag = { x: e.clientX, a: ringTarget }; e.currentTarget.setPointerCapture(e.pointerId); });
$('#drag').addEventListener('pointermove', e => { if (!drag) return; ringTarget = drag.a + (e.clientX - drag.x) * .006; });
const endDrag = () => { if (!drag) return; drag = null; ringTarget = Math.round(ringTarget / STEP) * STEP; lastAuto = performance.now(); };
$('#drag').addEventListener('pointerup', endDrag); $('#drag').addEventListener('pointercancel', endDrag);

function setActive(i) {
  if (i === active) return; active = i;
  gsap.to('#hName', { duration: .7, scrambleText: { text: F[i].name, chars: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', speed: .8 } });
  $('#hIdx').textContent = '0' + (i + 1); blip(1600, .04, .04);
}

/* ---------------- poses ---------------- */
function pose(x, y, z, rx, ry, rz, s = 1) { return { x, y, z, rx, ry, rz, s }; }
function mix(a, b, t) { const o = {}; for (const k in a) o[k] = lerp(a[k], b[k], t); return o; }
function apply(o, p) { o.position.set(p.x, p.y, p.z); o.rotation.set(p.rx, p.ry, p.rz); o.scale.setScalar(p.s); }
const tmpV = new THREE.Vector3();

/* ---------------- colour state ---------------- */
const cA = new THREE.Color(), cB = new THREE.Color(), cC = new THREE.Color(), cD = new THREE.Color();
const NEUTRAL_GLOW = new THREE.Color('#5b5b5b'), NEUTRAL_BASE = new THREE.Color('#050505');
const root = document.documentElement.style;
const bgS = document.getElementById('bg').style, railEl = document.getElementById('rail');
let lastCss = '', lastBright = '', lastRail = -1, lastBw = -1, lastCanvasO = -1, curFBlk = null;
const OVS = [];

/* ---------------- loop ---------------- */
const clock = new THREE.Clock();
function frame() {
  const dt = Math.min(clock.getDelta(), .05), t = clock.elapsedTime;
  const m = mob();
  const kd = 1 - Math.exp(-dt * 4.2);
  for (const k in P) { P[k] += (PR[k] - P[k]) * kd; if (Math.abs(PR[k] - P[k]) < 1e-5) P[k] = PR[k]; }

  // hero ring rotation (auto-advance)
  const inHero = P.hero < .2 && P.flavors === 0;
  if (inHero && !drag && performance.now() - lastAuto > 4200 && introT >= 1) { go(1); }
  ringA += (ringTarget - ringA) * (1 - Math.exp(-dt * 5));
  const frontIdx = ((Math.round(-ringA / STEP) % N) + N) % N;
  setActive(frontIdx % 3);
  if (P.hero < .12) lockedFlavor = null; else if (lockedFlavor === null) { lockedFlavor = active; }

  const tH = ease(clamp01((P.hero - .25) / .75));             // ring -> flavour
  const tB = ease(clamp01(P.benefits / .18));                  // flavour -> benefits
  const tM = ease(clamp01(P.manifest / .4));                   // benefits -> manifest
  const tL = ease(clamp01(P.lineup / .35));                    // manifest -> lineup
  const tOut = clamp01((P.lineup - .8) / .2);                  // fade canvas out

  // ring layout
  const ringScale = m ? .74 : .86;
  ring.position.set(0, -RING_R * Math.sin(.16) + (m ? .15 : .1) - tH * 1.2, -RING_R);
  ring.rotation.x = -.16;
  let frontPose = null;
  ringCans.forEach((c, i) => {
    const a = i * STEP + ringA;
    const cosA = Math.cos(a), sinA = Math.sin(a);
    const vis = clamp01((cosA - .12) / .25);
    const rise = clamp01(introT * 1.7 - (Math.abs(sinA) * .7));
    const spread = 1 + tH * 1.4;
    c.position.set(sinA * RING_R * spread, Math.sin(t * .9 + i) * .06 - (1 - ease(rise)) * 7 - tH * Math.abs(sinA) * 3, cosA * RING_R);
    c.rotation.set(-.05 + Math.sin(t * .6 + i) * .03, a + .25 * Math.sin(t * .4 + i * 2), -.22 * sinA + .1 * Math.sin(i * 1.7));
    const isFront = i === frontIdx;
    const da = Math.abs(Math.atan2(sinA, cosA));
    const lit = Math.pow(smooth(clamp01(1 - da / (STEP * .95))), 1.4);
    dimCan(c, lerp(.11, 1, Math.max(lit, tH)));
    c.scale.setScalar(ringScale * vis * (isFront ? (tH > 0 ? 0 : 1) : (1 - smooth(clamp01(tH * 1.5)))));
    if (isFront) { c.updateMatrixWorld(); c.getWorldPosition(tmpV); frontPose = pose(tmpV.x, tmpV.y, tmpV.z, c.rotation.x - .16, 0, c.rotation.z, ringScale * vis); }
  });
  ring.visible = tH < .97;
  const heroOn = (1 - tH) * ease(clamp01(introT));
  spot.intensity = 70 * heroOn; spot.target.position.set(0, -.2, 0);
  beam.material.uniforms.uO.value = heroOn * (.85 + .15 * Math.sin(t * 2.3));
  beam.visible = heroOn > .01; beam.scale.setScalar(m ? .8 : 1); beam.position.y = m ? -.05 : 0;

  // pedestals
  pedBot.position.set(0, (m ? -1.6 : -1.62) - tH * 4 - (1 - ease(clamp01(introT))) * 3, -.1);
  pedTop.position.set(0, (m ? 1.95 : 1.9) + tH * 4 + (1 - ease(clamp01(introT))) * 3, -1.2);
  pedBot.rotation.y = t * .1; pedTop.rotation.y = -t * .1;
  pedBot.visible = pedTop.visible = tH < .97;
  floor.position.y = -2.5 - tH * 3; floor.material.opacity = .32 * (1 - tH); floor.visible = tH < .97;
  pedBot.scale.setScalar(m ? .6 : .72); pedTop.scale.setScalar(m ? .6 : .72);

  // flavour step / spin
  const fp = P.flavors * 3, k = Math.min(2, Math.floor(fp)), local = fp - k;
  const spin = Math.min(2, k + ease(clamp01((local - .6) / .4)));
  const ord = order();
  const fStep = Math.min(2, Math.round(spin));
  const texIdx = ord[P.benefits > 0 ? 2 : fStep];

  // hero can pose chain
  const fPose = m ? pose(.3, .95, 1.4, .22, 0, .42, 1) : pose(1.25, -.35, 2.6, .24, 0, .42, 1);
  lidTilt += ((OPEN.t > 0 ? 1 : 0) - lidTilt) * (1 - Math.exp(-dt * 3));
  fPose.ry = spin * Math.PI * 2 + (local - .5) * .5 * (1 - tB) + Math.sin(t * .5) * .05;
  const bf = Math.max(0, (P.benefits - .18) / .205);
  const hi = P.benefits <= 0 ? -1 : Math.min(3, Math.floor(bf));
  const bi = Math.min(3, Math.floor(bf)), bfr = bi >= 3 ? 0 : ease(clamp01((bf - bi - .55) / .45));
  const rowPx = lerp(ROWS_Y[bi], ROWS_Y[Math.min(3, bi + 1)], bfr);
  const rowY = (.5 - rowPx / LH) * H;
  const bPose = m ? pose(.2, -rowY + 1.05, 2.4, .08, Math.PI * 6 + Math.PI, .08, 1) : pose(.35, -rowY + .05, 4.2, .08, Math.PI * 6 + Math.PI + Math.sin(t * .5) * .06, .1, 1);
  const mPose = pose(0, m ? .15 : .05, m ? 1.4 : 2.4, .05, Math.PI * 7 + P.manifest * Math.PI * 2, -.18, m ? .95 : 1.05);
  mPose.rx += .55 * lidTilt * (1 - tL); mPose.y -= .55 * lidTilt * (1 - tL);
  // can opening (pshitt + splash) in the PURE BLOOD scene
  if (P.manifest > .3 && P.lineup <= 0 && !OPEN.armed) {
    OPEN.armed = true; gsap.killTweensOf(OPEN); OPEN.burst = false;
    gsap.fromTo(OPEN, { t: 0 }, { t: 1, duration: 1.7, ease: 'none', delay: .15, onStart: () => blip(2400, .025, .05) });
  }
  if (P.manifest < .12 && OPEN.armed) { OPEN.armed = false; gsap.to(OPEN, { t: 0, duration: .35, overwrite: true, onComplete: () => { OPEN.burst = false; } }); }
  const lPose = pose(-1.5, -6, 2, .3, mPose.ry + 1, .6, 1);

  let hp;
  if (!frontPose) frontPose = pose(0, 0, 0, 0, 0, 0, 1);
  hp = mix(frontPose, fPose, tH);
  hp.ry = lerp(0, fPose.ry, tH);
  if (tB > 0) hp = mix(hp, bPose, tB);
  if (tM > 0) hp = mix(hp, mPose, tM);
  if (tL > 0) hp = mix(hp, lPose, tL);
  if (tH > 0) hp.y += Math.sin(t * 1.1) * .04 * (1 - tB);
  apply(heroCan, hp);
  const hcu = heroCan.userData.can && heroCan.userData.can.userData;
  if (hcu) {
    const ot = OPEN.t;
    hcu.tabPivot.rotation.x = ot < .42 ? ease(ot / .42) * 1.1 : lerp(1.1, .28, ease(clamp01((ot - .42) / .38)));
    hcu.panelPivot.rotation.x = ease(clamp01((ot - .16) / .28)) * 1.5;
    if (ot >= .28 && !OPEN.burst && heroCan.visible) { OPEN.burst = true; burst(heroCan.userData.can, F[texIdx].can); pshitt(); }
  }
  updateSplash(dt);
  heroCan.visible = tH > 0 && tL < 1;

  // hero texture (flavour + highlighted benefit row)
  if (texIdx !== curTex) {
    curTex = texIdx;
    gsap.killTweensOf(OPEN); OPEN.t = 0; OPEN.burst = false;
    const hm = heroCan.userData.body.material; hm.map = HERO_TEX[texIdx]; hm.metalnessMap = hm.roughnessMap = MR_TEX[texIdx];
    setCanFlavor(heroCan.userData.can, texIdx);
    OVS.forEach((o, i) => { o.material.map = ROW_TEX[texIdx][i]; });
  }
  const benOn = P.benefits > .14 && P.manifest <= .02;
  const ko = 1 - Math.exp(-dt * 7);
  OVS.forEach((o, i) => { const tg = benOn && i === hi ? 1 : 0; o.material.opacity += (tg - o.material.opacity) * ko; o.visible = o.material.opacity > .003; });

  // flavour text
  const inFlavors = P.flavors > 0 && P.benefits <= .05 && tH >= .85;
  const wantF = inFlavors ? fStep : -1;
  if (wantF !== curFStep) {
    const blks = $$('#fTxt .blk'), prev = curFBlk, nb = wantF >= 0 ? blks[ord[wantF]] : null;
    curFBlk = nb;
    if (nb) { showBlk(nb, prev); whoosh(); }
    if (!nb && prev) { gsap.to(prev.querySelectorAll('h2 [class*="char"]'), { yPercent: -110, duration: .4, stagger: .01, overwrite: true }); gsap.to(prev.querySelectorAll('p [class*="line"], .notes span'), { autoAlpha: 0, duration: .3, overwrite: true, onComplete: () => prev.classList.remove('on') }); }
    curFStep = wantF;
    if (wantF >= 0) {
      const nm = F[ord[wantF]].name.toUpperCase().replace(' ', '  ');
      $('#letters').innerHTML = lettersOf(nm); $('#lettersTop').innerHTML = lettersOf(nm);
      gsap.fromTo('#letters span, #lettersTop span', { opacity: 0 }, { opacity: 1, duration: .6, stagger: { each: .03, from: 'random' } });
      $('#fIdx').textContent = '0' + (wantF + 1);
      $$('#fCount i').forEach((el, j) => el.classList.toggle('on', j === wantF));
    }
  }
  // benefits text + rail
  const wantB = P.benefits > .14 && P.manifest <= .02 ? hi : -1;
  if (wantB !== curBStep) {
    const blks = $$('#bTxt .blk'), prev = blks[curBStep];
    if (wantB >= 0) { showBlk(blks[wantB], prev); blip(1300, .05, .04); }
    else if (prev) { gsap.to(prev.querySelectorAll('h2 [class*="char"]'), { yPercent: -110, duration: .4, overwrite: true }); gsap.to(prev.querySelectorAll('p [class*="line"], .chip'), { autoAlpha: 0, duration: .3, overwrite: true, onComplete: () => prev.classList.remove('on') }); }
    curBStep = wantB;
    $$('#rail button').forEach((b, j) => b.classList.toggle('on', j === wantB));
  }
  const railA = +(clamp01(P.benefits * 10) * (1 - clamp01(P.manifest * 8))).toFixed(3);
  if (railA !== lastRail) { lastRail = railA; railEl.style.opacity = railA; railEl.style.visibility = railA > 0 ? 'visible' : 'hidden'; }

  // big word
  const bw = clamp01(P.manifest * 4) * (1 - clamp01((P.manifest - .8) / .15)) * (1 - tL);
  const bwEl = $('#bigword'); const bwR = +bw.toFixed(3);
  if (bwR !== lastBw) { lastBw = bwR; bwEl.style.opacity = bwR; }
  if (bwR > 0) bwEl.firstElementChild.style.transform = `scale(${(1.25 - .25 * ease(clamp01(P.manifest * 2))).toFixed(4)}) translateY(${((.5 - P.manifest) * 6).toFixed(2)}vh)`;

  // lineup
  line.visible = tL > 0 && tOut < 1;
  const slide = P.lineup * (m ? 9 : 11);
  lineCans.forEach((c, i) => {
    const s = i * .98 - slide + 5;
    const enter = ease(clamp01(tL * 1.8 - i * .04));
    c.position.set(s * .93 - 1.2, s * .3 - .6 - (1 - enter) * 6, -s * .45 - 1.2);
    c.rotation.set(.1, -.35 + Math.sin(t * .5 + i) * .05, .22 + Math.sin(t * .7 + i) * .02);
    c.scale.setScalar(m ? .8 : 1);
  });
  const cO = +(1 - tOut).toFixed(3); if (cO !== lastCanvasO) { lastCanvasO = cO; canvas.style.opacity = cO; canvas.style.visibility = cO > 0 ? 'visible' : 'hidden'; }

  // colours
  const fA = F[ord[Math.min(2, Math.floor(spin))]], fB = F[ord[Math.min(2, Math.ceil(spin))]], fr = spin - Math.floor(spin);
  cA.set(fA.glow).lerp(cB.set(fB.glow), fr); cC.set(fA.deep).lerp(cD.set(fB.deep), fr);
  const glow = NEUTRAL_GLOW.clone().lerp(cA, tH), base = NEUTRAL_BASE.clone().lerp(cC, tH);
  const fEnd = F[ord[2]];
  if (tB > 0) { glow.lerp(cA.set(fEnd.glow).multiplyScalar(.55), tB); base.lerp(cC.set('#020202'), tB); }
  if (tM > 0) { glow.lerp(cA.set(fEnd.bright), tM); base.lerp(cC.set(fEnd.glow).multiplyScalar(.75), tM); }
  if (tL > 0) { glow.lerp(NEUTRAL_GLOW, tL); base.lerp(NEUTRAL_BASE, tL); }
  const spotCss = (1 - tH) + tL;
  const css = `${glow.getHexString()}|${base.getHexString()}|${spotCss.toFixed(2)}|${tM.toFixed(2)}`;
  if (css !== lastCss) {
    lastCss = css;
    bgS.setProperty('--glow', '#' + glow.getHexString()); bgS.setProperty('--base', '#' + base.getHexString());
    bgS.setProperty('--spot', spotCss.toFixed(3)); bgS.setProperty('--g2', (tM * (1 - tL)).toFixed(3));
    railEl.style.setProperty('--glow', '#' + glow.getHexString());
  }
  const br = F[lockedFlavor ?? active].bright; if (br !== lastBright) { lastBright = br; root.setProperty('--bright', br); }
  rimL.color.copy(glow).lerp(new THREE.Color('#ffffff'), .15); rimR.color.copy(rimL.color);
  rimL.intensity = rimR.intensity = 30 + tM * 40;
  key.intensity = lerp(1.3, 2.6, tH);

  // camera parallax
  camera.position.x += ((pointer.x * .25) - camera.position.x) * .04;
  camera.position.y += ((-pointer.y * .15) - camera.position.y) * .04;
  camera.lookAt(0, 0, 0);

  renderer.render(scene, camera);
}
const pointer = { x: 0, y: 0 };
addEventListener('pointermove', e => { pointer.x = e.clientX / innerWidth * 2 - 1; pointer.y = e.clientY / innerHeight * 2 - 1; });

function resize() {
  const w = innerWidth, h = innerHeight;
  renderer.setSize(w, h, false); camera.aspect = w / h;
  camera.fov = w / h < .8 ? 44 : w / h < 1.2 ? 34 : 28;
  camera.updateProjectionMatrix();
}
addEventListener('resize', () => { resize(); ScrollTrigger.refresh(); });
resize();

/* ---------------- boot ---------------- */
(async () => {
  // blood-drop loader: the drop of the logo fills up with the loading progress
  const LD = { shown: 0 }, fillEl = $('#loader .fill'), t0 = performance.now();
  const ldTick = () => {
    const lvl = 100 - LD.shown * 100, amp = LD.shown > .01 && LD.shown < .995 ? 2.4 : 0, tt = performance.now() / 1000;
    const pts = [];
    for (let i = 0; i <= 14; i++) pts.push((i / 14 * 100).toFixed(1) + '% ' + Math.max(0, Math.min(100, lvl + Math.sin(tt * 4.2 + i * .85) * amp)).toFixed(2) + '%');
    fillEl.style.clipPath = 'polygon(' + pts.join(',') + ',100% 100%,0% 100%)';
    $('#pct').textContent = String(Math.round(LD.shown * 100)).padStart(3, '0');
  };
  gsap.ticker.add(ldTick);
  const setL = v => gsap.to(LD, { shown: v, duration: .9, ease: 'power2.out', overwrite: true });
  const img = await loadImg(LOGO_SRC);
  const logoURL = whiteLogo(img, [150, 555, 1240, 520]).toDataURL('image/png');
  const putImg = (el, url) => { const i = new Image(); i.alt = el.dataset.logo !== undefined ? 'Gjak' : ''; i.src = url; el.replaceChildren(i); };
  $$('[data-logo]').forEach(el => putImg(el, logoURL));
  putImg($('#ldLogo'), whiteLogo(img, [150, 555, 1240, 520], false).toDataURL('image/png'));
  const dropURL = dropOnly(img); $$('#loader .drop span').forEach(el => el.style.backgroundImage = 'url(' + dropURL + ')');
  gsap.to('#ldLogo', { opacity: 1, duration: 1.2, ease: 'power2.out' });
  setL(.2);
  WORD = whiteLogo(img, [160, 565, 1215, 380]);
  WORD_MR = tint(WORD, 'rgb(0,150,12)');
  await Promise.race([Promise.all(['900 italic 60px Archivo', '500 60px "Bodoni Moda"', 'italic 500 30px "Bodoni Moda"', '400 20px Geist', '500 20px "Geist Mono"'].map(f => document.fonts.load(f))), new Promise(r => setTimeout(r, 2500))]);
  await Promise.race([document.fonts.ready, new Promise(r => setTimeout(r, 2500))]);
  buildTexts();
  setL(.45);
  MR_TEX = F.map(f => makeMRTex(renderer, f));
  LABELS = F.map(f => makeLabelTex(f, renderer)); setL(.65);
  HERO_TEX = F.map(f => makeLabelTex(f, renderer, 99)); setL(.8);
  F.forEach((f, fi) => { ROW_TEX[fi] = B.map((_, i) => makeRowTex(f, i, renderer)); });
  BODY_MATS = LABELS.map((t, i) => bodyMat(t, i));
  CAP_MATS = F.map(f => ({ cap: capMat(f), tab: tabMat(f) }));
  for (let i = 0; i < N; i++) { const c = makeCan(BODY_MATS[i % 3], i % 3, true); ringCans.push(c); ring.add(c); }
  const hc = makeCan(bodyMat(HERO_TEX[0], 0), 0); heroCan.add(hc); heroCan.userData.body = hc.userData.body; heroCan.userData.can = hc;
  { const th = ROW_W / LW * Math.PI * 2, h = ROW_H / LH * H;
    B.forEach((_, i) => {
      const o = new THREE.Mesh(new THREE.CylinderGeometry(R * 1.004, R * 1.004, h, 64, 1, true, Math.PI - th / 2, th),
        new THREE.MeshBasicMaterial({ map: ROW_TEX[0][i], transparent: true, opacity: 0, depthWrite: false, toneMapped: false }));
      o.position.y = (.5 - (ROWS_Y[i] - ROW_OFF + ROW_H / 2) / LH) * H; o.visible = false; hc.add(o); OVS.push(o);
    }); }
  for (let i = 0; i < 15; i++) { const c = makeCan(BODY_MATS[i % 3], i % 3); lineCans.push(c); line.add(c); }
  // product shots for the shop cards
  {
    const shotScene = new THREE.Scene(); shotScene.environment = scene.environment;
    const sk = new THREE.DirectionalLight(0xffffff, 2.4); sk.position.set(-3, 5, 6); shotScene.add(sk, new THREE.AmbientLight(0xffffff, .2));
    const sr = new THREE.PointLight(0xffffff, 30, 20); sr.position.set(3, 1, -2); shotScene.add(sr);
    const cam = new THREE.PerspectiveCamera(22, 1, .1, 50); cam.position.set(0, .2, 7.6); cam.lookAt(0, 0, 0);
    renderer.setSize(640, 640, false);
    F.forEach((f, i) => {
      const c = makeCan(BODY_MATS[i], i); c.rotation.set(.12, -.25, 0); shotScene.add(c);
      renderer.render(shotScene, cam);
      const url = canvas.toDataURL('image/png');
      $$(`[data-shot="${i}"]`).forEach(im => im.src = url);
      shotScene.remove(c);
    });
    resize();
  }
  // warm up GPU
  renderer.compile(scene, camera);
  gsap.ticker.add(frame);
  await gsap.to(LD, { shown: 1, duration: Math.max(.9, 2.6 - (performance.now() - t0) / 1000), ease: 'power2.inOut', overwrite: true });
  gsap.ticker.remove(ldTick); ldTick();
  const dr = $('#loader .drop').getBoundingClientRect(), burst = $('#loader .burst');
  const cx = dr.left + dr.width / 2, cy = dr.top + dr.height * .7, far = Math.hypot(Math.max(cx, innerWidth - cx), Math.max(cy, innerHeight - cy));
  gsap.set(burst, { x: cx, y: cy });
  const tl = gsap.timeline();
  tl.to('#loader .drop', { scale: 1.14, duration: .28, ease: 'power2.out' })
    .to('#loader .drop', { scale: 1, duration: .5, ease: 'elastic.out(1,.45)' })
    .to('#ldLogo, #pct', { opacity: 0, duration: .45, ease: 'power2.in' }, '<')
    .to(burst, { scale: far / 18, duration: 1.05, ease: 'expo.in' }, '<.1')
    .to('#loader .drop', { opacity: 0, duration: .3 }, '-=.35')
    .to('#loader', { clipPath: 'inset(0 0 100% 0)', duration: 1.1, ease: 'expo.inOut' }, '+=.05')
    .to({ v: 0 }, { v: 1, duration: 2.4, ease: 'power2.out', onUpdate() { introT = this.targets()[0].v; } }, '-=.8')
    .fromTo('.top > *', { y: -30, opacity: 0 }, { y: 0, opacity: 1, duration: 1, stagger: .08, ease: 'expo.out' }, '<.3')
    .fromTo('.hero-ui > *, .hero-count, .hero-tag', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 1, stagger: .08, ease: 'expo.out' }, '<.4')
    .add(() => { document.body.classList.remove('is-loading'); $('#loader').style.display = 'none'; lenis.start(); ScrollTrigger.refresh(); lastAuto = performance.now(); });
})();
